var exports = {
  "h": "xe533113f--863f46--description",
};

module.exports = exports;
